<tilby-dialog-toolbar mat-dialog-title
    [title]="title"
    [disabled]="!saleForm?.valid"
    (confirm)="confirm()"
/>
<tilby-dialog-content>
    @if(saleForm) {
        <tilby-magic-form [form]="saleForm"/>
    }
</tilby-dialog-content>